import styled from 'styled-components'

const Label = styled.div`
  color: #00a8eb;
  font-size: 13px;
  padding: 12px 0;
`
export default Label
